/**
 * Approximate centroids for NY/NJ 3-digit ZIP prefixes. Used only to estimate
 * "within X miles of a ZIP" in the soil data library — not for exact locations.
 */
export const ZIP3_CENTROIDS: Record<string, [number, number]> = {
  // New Jersey
  "070": [40.74, -74.2], "071": [40.73, -74.17], "072": [40.66, -74.21], "073": [40.72, -74.06],
  "074": [41.0, -74.3], "075": [40.92, -74.17], "076": [40.92, -74.04], "077": [40.27, -74.1],
  "078": [40.86, -74.65], "079": [40.79, -74.48], "080": [39.83, -75.0], "081": [39.93, -75.1],
  "082": [39.4, -74.6], "083": [39.45, -75.1], "084": [39.36, -74.43], "085": [40.25, -74.62],
  "086": [40.22, -74.75], "087": [39.98, -74.18], "088": [40.52, -74.45], "089": [40.49, -74.45],
  // New York
  "100": [40.78, -73.97], "101": [40.75, -73.98], "102": [40.71, -74.01], "103": [40.58, -74.15],
  "104": [40.84, -73.87], "105": [41.03, -73.76], "106": [41.03, -73.76], "107": [40.93, -73.89],
  "108": [40.91, -73.78], "109": [41.15, -74.0], "110": [40.73, -73.7], "111": [40.75, -73.92],
  "112": [40.65, -73.95], "113": [40.74, -73.85], "114": [40.69, -73.8], "115": [40.72, -73.6],
  "116": [40.6, -73.77], "117": [40.8, -73.2], "118": [40.75, -73.5], "119": [40.9, -72.6],
  "120": [42.65, -73.75], "121": [42.6, -73.85], "122": [42.65, -73.78], "123": [42.8, -73.93],
  "124": [41.95, -74.1], "125": [41.7, -73.9], "126": [41.7, -73.92], "127": [41.65, -74.7],
  "128": [43.3, -73.7], "129": [44.7, -73.6], "130": [43.05, -76.15], "131": [43.0, -76.2],
  "132": [43.05, -76.15], "133": [43.1, -75.25], "134": [43.1, -75.3], "135": [43.1, -75.23],
  "136": [44.4, -75.3], "137": [42.1, -75.9], "138": [42.1, -75.9], "139": [42.1, -75.95],
  "140": [42.9, -78.75], "141": [42.85, -78.6], "142": [42.89, -78.86], "143": [43.1, -79.0],
  "144": [43.15, -77.6], "145": [43.0, -77.5], "146": [43.16, -77.61], "147": [42.1, -79.25],
  "148": [42.1, -76.8], "149": [42.1, -76.8],
};

export function zipCentroid(zip: string): [number, number] | null {
  const z = (zip ?? "").trim();
  if (!/^\d{5}$/.test(z)) return null;
  return ZIP3_CENTROIDS[z.slice(0, 3)] ?? null;
}

export function milesBetween(a: [number, number], b: [number, number]): number {
  const rad = (d: number) => (d * Math.PI) / 180;
  const dLat = rad(b[0] - a[0]);
  const dLng = rad(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLng / 2) ** 2;
  return 3958.8 * 2 * Math.asin(Math.sqrt(h));
}
